<script setup>
import { useI18n } from 'vue-i18n'
import { NEWS_CATEGORIES } from '@/lib/news'

/**
 * The news filter: the icon beside the heading, and the categories to tick. The choice is the reader's
 * (see lib/news, saved on the device), so this component only shows it and hands the new one back.
 */
const props = defineProps({
  modelValue: { type: Array, default: () => [] },
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()

/** Toggle a category; the last one left on cannot be turned off (an empty list explains nothing). */
function toggle(category) {
  const next = props.modelValue.includes(category)
    ? props.modelValue.filter(item => item !== category)
    : [...props.modelValue, category]

  emit('update:modelValue', next.length ? next : [category])
}
</script>

<template>
  <v-menu :close-on-content-click="false" location="bottom end">
    <template #activator="{ props: menu }">
      <v-btn
        v-bind="menu"
        icon="mdi-filter-variant"
        size="small"
        density="comfortable"
        variant="tonal"
        :title="t('news.filter')"
        :color="modelValue.length < NEWS_CATEGORIES.length ? 'primary' : undefined"
      />
    </template>

    <v-list density="comfortable" min-width="200">
      <v-list-subheader>{{ t('news.filter') }}</v-list-subheader>
      <v-list-item v-for="category in NEWS_CATEGORIES" :key="category" @click="toggle(category)">
        <template #prepend>
          <v-checkbox-btn :model-value="modelValue.includes(category)" class="mr-2" />
        </template>
        <v-list-item-title>{{ t(`news.categories.${category}`) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
